import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import isDarkOnColor from "../../../utils/isDarkOnColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import { cssTextAtm } from "../../atoms/TextAtm/TextAtm.styled";
import Link from "../../quarks/Link";
var largeBreakpointValue = "large";
var borderBottomValue = 1;

/**
 * 1. Preventing text from jumping on hover, when font-weight is changing.
 * https://stackoverflow.com/questions/556153/inline-elements-shifting-when-made-bold-on-hover
 */

export var Container = styled.div.withConfig({
  componentId: "sc-127f2hr-0"
})(function (_ref) {
  var $hasFullWidth = _ref.$hasFullWidth,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;align-items:stretch;> *{flex:1;}", ";", "{display:inline-flex;border-bottom:", " solid ", ";", ";}"], $hasFullWidth ? css(["width:100%;"]) : null, breakpoint(largeBreakpointValue), unit(borderBottomValue), getBorderColor(theme, $onColor, "low"), !$hasFullWidth ? css(["min-width:", ";"], space(120)) : null);
});
var itemGutterStyles = function itemGutterStyles($gutterSpace) {
  return css(["margin-right:", ";padding-right:0;padding-left:0;&:last-child{margin-right:0;}"], space($gutterSpace));
};
var linkStyles = function linkStyles($gutterSpace, $onColor, $isActive, $borderColor) {
  return css(function (_ref2) {
    var theme = _ref2.theme;
    return css(["", ";&::after{content:\"\";position:absolute;bottom:", ";left:0;width:0;height:", ";background:", ";}", ""], itemGutterStyles($gutterSpace), unit(-borderBottomValue), unit(2), $borderColor ? getColor(theme, $borderColor) : getBorderColor(theme, $onColor, "high"), $isActive ? css(["&::after{", ";width:100%;}"], transition("width")) : null);
  });
};
export var StyledLink = styled(Link).withConfig({
  componentId: "sc-127f2hr-1"
})(function (_ref3) {
  var $isActive = _ref3.$isActive,
    $gutterSpace = _ref3.$gutterSpace,
    $borderColor = _ref3.$borderColor,
    $onColor = _ref3.$onColor,
    $typography = _ref3.$typography,
    $activeTypography = _ref3.$activeTypography,
    $hasMobileLinksView = _ref3.$hasMobileLinksView,
    theme = _ref3.theme;
  return css(["", ";position:relative;padding:", ";border:0;background:none;text-align:center;cursor:pointer;min-width:fit-content;&::before{content:attr(title);display:block;visibility:hidden;height:0;overflow:hidden;font-weight:bold;}", " ", ""], cssTextAtm({
    typography: $typography,
    onColor: $onColor
  }), space(1), $hasMobileLinksView ? css(["", ";"], linkStyles($gutterSpace, $onColor, $isActive, $borderColor)) : css(["", "{", ";}", "{", ";padding:", " ", ";border:", " solid ", ";border-radius:", ";margin-right:", ";&:last-child{margin-right:0;}", "}"], breakpoint(largeBreakpointValue), linkStyles($gutterSpace, $onColor, $isActive, $borderColor), breakpoint("small", largeBreakpointValue), cssTextAtm({
    typography: $typography,
    onColor: $onColor,
    emphasis: "medium"
  }), space(1.5), space(3), unit(1), getBorderColor(theme, $onColor, "medium"), getBorderRadius(theme, "xlarge"), space(1.5), $isActive && css(["border:", " solid ", ";background:", ";", ";"], unit(1), getBorderColor(theme, $onColor, "high"), isDarkOnColor(theme, $onColor) ? getColor(theme, "white") : getColor(theme, "backgroundBlack"), cssTextAtm({
    typography: $activeTypography,
    onColor: isDarkOnColor(theme, $onColor) ? "white" : "backgroundBlack",
    emphasis: "high"
  }))), $isActive ? css(["", ""], cssTextAtm({
    typography: $activeTypography,
    onColor: $onColor
  })) : css(["&:hover{", ";}"], cssTextAtm({
    typography: $activeTypography,
    onColor: $onColor
  })));
});